module.exports = __webpack_public_path__ + "static/img/img_news.56fe1e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img_news.jpg
// module id = 8aAJ
// module chunks = 1